import { Route } from 'vue-router';
import { Next } from '@cnamts/vue-dot/src/types';
import { store } from '@/store';

export async function isLogged(to: Route, from: Route, next: Next): Promise<void> {
	const logged = store.getters['appState/logged'];
	if (!logged) {
		const token = sessionStorage.getItem('token');
		if (!token) {
			next({ name: 'login' });
			return;
		}
		const success = await store.dispatch('appState/login', token);
		if (!success) {
			await store.dispatch('appState/logout');
			next({ name: 'login' });
			return;
		}
	}
	next();
}

export async function isAlreadyLogged(to: Route, from: Route, next: Next): Promise<void> {
	const logged = store.getters['appState/logged'];
	if (logged || sessionStorage.getItem('token')) {
		next({ name: 'dashboard' });
		return;
	}
	next();
}